export default __webpack_public_path__ + "static/media/main_bg_right_one.9eee2c6d.svg";